import styled from 'styled-components';

export const CheckoutContainer = styled.div`
  .half-grey {
    position: relative;

    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      z-index: 0;
      background-color: #fafafa;
      width: 55%;
    }

    &.full {
      &::before {
        width: 100%;
      }
    }
  }

  .signin-btn-area {
    text-align: right;
  }
  .signin-btn-area a {
    color: #161616;
    font-size: 14px;
    font-weight: bold;
    line-height: 17px;
    min-width: 121px;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
    background-color: #ffffff;
    display: inline-block;
    text-align: center;
    padding: 11px;
  }
  .signin-btn-area a:hover {
    background-color: ${({ theme: { colors } }) => colors.pink};
    color: #fff;
    border: 1px solid ${({ theme: { colors } }) => colors.pink};
  }
  .number-select-input {
    max-width: 85px;
    border: 1px solid #e1e1e1;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: auto;
  }
  .input-number {
    color: ${({ theme: { colors } }) => colors.pink};
    font-size: 10px;
    letter-spacing: 0.15px;
    line-height: 16px;
    text-align: right;
  }
  .input-num-box {
    display: inline-block;
    width: 30px;
    border: none;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.21px;
  }
  .checkout-area-main {
    padding: 30px 0 100px;
  }
  .checkout-white-box {
    background-color: #fff;
    padding: 8px 30px;
    margin-bottom: 16px;

    @media only screen and (max-width: 767px) {
      padding: 8px 0;
    }

    .errors {
      padding: 0;
      margin: 0;

      li {
        margin: 0;
        padding: 10px 0;
        margin-left: 15px;
        padding-left: 5px;
        color: ${({ theme: { colors } }) => colors.pink};
      }
    }
  }
  .checkout-head {
    padding-bottom: 6px;
    margin-bottom: 25px;
    color: #1d1d1d;
    font-size: 36px;
    font-weight: bold;
    letter-spacing: -0.6px;
    line-height: 44px;
  }
  .form-head {
    color: #1d1d1d;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 0.9px;
    line-height: 30px;
    border-bottom: 0.5px solid #d1d1d1;
    margin: 0 -30px 20px;
    padding: 5px 30px 12px;
  }
  .checkout-label {
    font-family: 'Proxima Nova';
    margin-bottom: 5px;
    display: inline-block;
    color: #1d1d1d;
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.16px;
    line-height: 16px;
    font-weight: 600;
  }
  .checkout-input {
    width: 100%;
    border: none;
    border-radius: 3px;
    background-color: #ffffff;
    height: 30px;
    padding: 0;
    color: #0a090b;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.21px;
    line-height: 16px;
  }
  .form-group {
    margin-bottom: 16px;
  }
  .form-group.checkout-single {
    padding: 10px 13px 5px;
    border: 1px solid #e1e1e1;
  }
  .add-person-btn {
    font-family: 'Proxima Nova';
    min-width: 168px;
    padding: 15px;
    background-color: #fff;
    color: #161616;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.1px;
    line-height: 17px;
    display: inline-block;
    text-align: center;
    border: 1px solid #e1e1e1;
  }
  .add-person-btn:hover {
    background-color: ${({ theme: { colors } }) => colors.pink};
    color: #fff;
    border: 1px solid ${({ theme: { colors } }) => colors.pink};
  }
  .term-label.contact-term {
    font-size: 13px;
    letter-spacing: -0.1px;
    line-height: 19px;
    font-weight: 400;
    font-family: 'Proxima Nova';
    padding-left: 35px;
    color: #111;
  }
  .contact-term::before {
    position: absolute;
    width: 19px;
    height: 19px;
    border: 1px solid ${({ theme: { colors } }) => colors.pink};
    border-radius: 3px;
    background-color: transparent;
    transition: 0.3s all;
    top: 0;
  }
  .contact-term::after {
    position: absolute;
    left: 0;
    width: 19px;
    height: 19px;
    border-radius: 0;
    background-color: transparent;
    content: '';
    font-family: 'Font Awesome 5 Pro';
    font-weight: 200;
    background-color: transparent;
    transition: 0.3s all;
    top: 0;
    bottom: 0;
    right: 0;
    text-align: center;
    color: #fff;
  }
  #term-checkbox:checked + .term-label::before {
    background-color: ${({ theme: { colors } }) => colors.pink};
  }
  .order-sum-head {
    color: #1d1d1d;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: -0.4px;
    line-height: 44px;
  }
  .table-checkout {
    width: 100%;
    border: none;
  }
  .table-checkout td {
    color: #1d1d1d;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.21px;
    line-height: 21px;
    vertical-align: top;
    width: 30%;
    padding: 8px 0;
    border: none;

    &:first-child {
      width: 70%;
    }
  }
  .form-divider {
    height: 1px;
    width: 100%;
    background-color: #e9e9e9;
    margin: 15px 0;
    display: block;
  }
  .table-checkout tr td.total-td {
    font-weight: 600;
    text-align: right;
    font-size: 28px;
    font-family: 'Proxima Nova';
    vertical-align: middle;
  }
  .checkout-btn {
    display: block;
    width: 100%;
    background-color: ${({ theme: { colors } }) => colors.pink};
    color: #fff;
    padding: 18px;
    border: none;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.1px;
    line-height: 17px;
    text-align: center;
  }
  .checkout-btn:hover {
    background-color: #e02e3a;
    color: #fff;
  }
  .checkout-btn i {
    margin-right: 5px;
  }
  .checkout-btn-area {
    margin: 50px 0 25px;
  }

  .StripeCheckout {
    width: 100%;
    background-color: ${({ theme: { colors } }) => colors.pink} !important;
    color: #fff !important;
    padding: 18px !important;
    border: none !important;
    font-size: 14px !important;
    font-weight: bold !important;
    letter-spacing: 0.1px !important;
    line-height: 17px !important;
    text-align: center !important;
  }

  .discount-area {
    input {
      padding: 13px 10px;
      width: calc(100% - 120px);
    }

    .pink-btn {
      padding: 10px;
      min-width: 100px;
    }

    .show-discount {
      color: ${({ theme: { colors } }) => colors.pink};
      font-size: 14px;
      letter-spacing: 0.1px;
      line-height: 17px;
    }
  }

  [disabled] {
    cursor: not-allowed;
  }

  @media (max-width: 767px) {
    .checkout-details {
      padding: 25px 0 0;
    }
    .checkout-area-main {
      padding: 0px 0 40px;
    }
    .half-grey::before {
      display: none;
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 10;
  cursor: not-allowed;
`;

export const SpinnerContainer = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const StyledBackButton = styled.button`
  outline: none !important;
  background: inherit;
  border: 0;
  position: relative;
  margin-top: 40px;
  @media (max-width: 767px) {
    margin-bottom: 30px;
  }
  @media (max-width: 989px) {
    margin-top: 10px;
  }
`;

export const BackButtonContainer = styled.span`
  display: flex;
  align-items: end;
  font-size: 14px;
`;
